<template>
  <v-card v-for="branch of branches?.data" :title="`${branch.name}`">
    <template v-slot:append>
      <v-icon icon="mdi-plus" @click="createRound(branch.id)">
        <v-tooltip activator="parent" location="end">Add New Round</v-tooltip>
      </v-icon>
    </template>

    <v-card-text>
      <v-row v-for="judingRound of roundsForBranch(branch)">
        <v-col>
          {{ judingRound.round }}
        </v-col>
        <v-col>
          <v-btn icon variant="text" color="primary" @click="openJudgeModal(judingRound)">
            <v-icon icon="mdi-gavel"></v-icon>
          </v-btn>
          <v-btn icon variant="text" color="primary" @click="openMovieModal(judingRound)">
            <v-icon icon="mdi-movie-open-outline"></v-icon>
          </v-btn>
          <v-btn icon variant="text" color="primary">
            <v-icon icon="mdi-trash-can-outline"></v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <v-dialog v-model="judgeOpen">
    <JudgeListingForBranchYearComponent
      :round="selectedRound"
      @snack="throwSnack"
      @close="judgeOpen = false"></JudgeListingForBranchYearComponent>
  </v-dialog>
  <v-dialog v-model="movieOpen">
    <JudgeSelectionAddEditComponent
      :round="selectedRound"
      @snack="throwSnack"></JudgeSelectionAddEditComponent>
  </v-dialog>
</template>
<script setup lang="ts">
import JudgeListingForBranchYearComponent from '@/components/judges/JudgeListingForBranchYearComponent.vue';
import JudgeSelectionAddEditComponent from '@/components/judges/JudgeSelectionAddEditComponent.vue';
import {
  BranchDTO,
  BranchYearRoundDTO,
  IBranchYearRoundDTO,
  IPaginationDTO,
  PaginationDTO,
} from '@/dtos';
import { useSnack } from '@/helpers';
import { useAdminJudgeStore, useBranchYearStore } from '@/stores/modules/admin';
import { SNACKSTATUS } from '@/stores/util';
import { computed, ref } from 'vue';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);

interface Props {
  yearId: string;
}
const props = defineProps<Props>();

const yearId = computed(() => props.yearId);
const judgeStore = useAdminJudgeStore();
const branchYearStore = useBranchYearStore();
const judgeOpen = ref<boolean>(false);
const movieOpen = ref<boolean>(false);
const selectedRound = ref<IBranchYearRoundDTO>(new BranchYearRoundDTO());
const pageOptionsBranchYears = ref<IPaginationDTO>(new PaginationDTO());
const pageOptionsRounds = ref<IPaginationDTO>(new PaginationDTO());
const { data: branches, isLoading: isLoadingBranchYears } = branchYearStore.getBranchesForYearQuery(
  yearId,
  pageOptionsBranchYears,
);

const { data: jugdingRounds, isLoading: isLoadingRounds } = judgeStore.getJudgingRounds(
  yearId,
  pageOptionsRounds,
);

const roundsForBranch = (branch: BranchDTO): BranchYearRoundDTO[] => {
  return (
    jugdingRounds.value?.data.filter((round) => round.branchYear.branch?.id === branch.id) ?? []
  );
};

const createRound = async (branchId: string) => {
  judgeStore.addRound.mutateAsync({ branchId: branchId, yearId: yearId.value });
};

const openJudgeModal = (round: IBranchYearRoundDTO) => {
  judgeOpen.value = true;
  selectedRound.value = round;
};
const openMovieModal = (round: IBranchYearRoundDTO) => {
  movieOpen.value = true;
  selectedRound.value = round;
};
</script>

<!--

1. Create Round
   3. Choose Films
3. Remove Rounds

-->
